import * as React from 'react';
import { useAnalytics } from 'telia-front-react';
export const withAnalytics = (Component) => {
    return function WrappedComponent(props) {
        const { push } = useAnalytics();
        return React.createElement(Component, { ...props, pushAnalytics: push });
    };
};
